import loadable from "@loadable/component";
import { inject } from "mobx-react";
import { Fragment, useMemo } from "react";
import { utcToZonedTime } from "date-fns-tz";
import { reverseRoute, isPublishRecord } from "@inferno/renderer-shared-core";
import { Heading, MagicLink } from "../../../../core/ui";
import { CoastFeedShowsProps } from "../../lib/coastFeed";
import { CoastFeedUpcomingShowsPreviewItem } from "./CoastFeedUpcomingShowsPreviewItem.component";

const CoastShowPlaceholder = loadable(() => import("../CoastShowPlaceholder.component"));

export const CoastFeedUpcomingShowsPreview = inject("store")(({ store, content, type, title }: CoastFeedShowsProps) => {
  if (!store || !content?.length) {
    return <CoastShowPlaceholder />;
  }

  const { site, page, env } = store;
  const timezone = site.index.timeZone || env.DEFAULT_TIMEZONE;

  const comparisonDate = useMemo(() => {
    const now = new Date();

    if (page.currentPage?.name !== "home" && page.currentPage !== null) {
      const tomorrow = new Date(now.getTime() - 24 * 60 * 60 * 1000);
      return utcToZonedTime(tomorrow, timezone);
    }

    return utcToZonedTime(now, timezone);
  }, [page.currentPage, timezone]);

  const sortedCards = useMemo(() => {
    const upcoming = content.filter(item => {
      const record = item?.record;

      if (!isPublishRecord(record)) {
        return false;
      }

      const sourceDate = record.payload?.fields?.show_date?.value || record.pub_start;
      let showDate = utcToZonedTime(new Date(sourceDate), timezone);

      showDate = new Date(showDate.getTime() - 4 * 60 * 60 * 1000);

      return showDate >= comparisonDate;
    });

    return upcoming.slice(0, 6);
  }, [content, comparisonDate, timezone]);

  if (!sortedCards?.length) {
    return <CoastShowPlaceholder />;
  }

  const moreLink = reverseRoute(site, "upcoming_shows");

  return (
    <Fragment>
      <Heading level={3}>{title}</Heading>
      <div className="upcoming-shows-preview">
        <div className="feed-cards">
          {sortedCards.map(item => (
            <CoastFeedUpcomingShowsPreviewItem key={item.id} item={item} type={type} />
          ))}
        </div>

        {moreLink ? (
          <div className="more-container">
            <MagicLink className="more" to={moreLink}>
              Full Schedule &raquo;
            </MagicLink>
          </div>
        ) : null}
      </div>
    </Fragment>
  );
});

export default CoastFeedUpcomingShowsPreview;
